import { configureIguazuSSR } from 'iguazu-holocron';
import { loadLanguagePack, updateLocale } from '@americanexpress/one-app-ducks';

export default async function loadModuleData({ store, module, ownProps }) {
  const { dispatch, getState } = store;
  const activeLocale = getState().getIn(['intl', 'activeLocale']);
  const caseCheckLocale = activeLocale.replace(/-.*/g, (region) => region.toUpperCase());
  if (caseCheckLocale !== activeLocale) {
    await dispatch(updateLocale(caseCheckLocale));
  }
  await configureIguazuSSR({ store, module, ownProps });
  await dispatch(loadLanguagePack('axp-maps-root', { fallbackLocale: 'en-US' }));
}
